import BaseApi from './base.api'
import Api from '@services/api.service'

export default {
    ...BaseApi,
    ...{
        resource: 'notifications-mongo'
    },
    uploadAttachments(data) {
        return Api.post('/notifications-mongo/upload-attachments', data)
    },
    
    // User notification endpoints
    getUserNotifications(params = null) {
        return Api.get('/user-notifications',  params )
    },
    
    getNotificationDetails(id) {
        return Api.get(`/user-notifications/${id}`)
    },
    
    markAsRead(id) {
        return Api.post(`/user-notifications/${id}/mark-as-read`)
    },
    
    markAllAsRead() {
        return Api.post('/user-notifications/mark-all-as-read')
    },
    
    getUnreadCount() {
        return Api.get('/user-notifications/unread-count')
    },
    
    getStats() {
        return Api.get('/user-notifications/stats')
    },
    
    getRecent(params = null) {
        return Api.get('/user-notifications/recent',  params )
    }
}


